import { render, staticRenderFns } from "./PageGLP.vue?vue&type=template&id=b80b7412&"
import script from "./PageGLP.vue?vue&type=script&lang=js&"
export * from "./PageGLP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports